import request from '@/util/request.js'
export const userInfo = (userId) => request({
  url: '/api/sansint-user/info',
  method: 'get',
  params: {
    userId
  }
})
export const getInformation = () => request({
  url: '/api/sansint-system/tenant/detail',
  method: 'get'
})
export const updatePassword = (oldPassword, newPassword, newPassword1) => {
  return request({
    url: '/api/sansint-user/update-password',
    method: 'post',
    params: {
      oldPassword,
      newPassword,
      newPassword
    }
  })
}
